@if (isDeviceInMobileView) {
  <div class="sidebar-container">
    <div (click)="toggleSidebarOpened()"
      [queryParams]="{'customerName': queryParamsConstant.all}" [routerLink]="[routeNavigationConstant.ksmDashboard]"
      class="mt-0 mb-12 py-8 px-20 font-size-16" routerLinkActive="active">
      <img alt="Home" class="mr-12 menu-image" src="assets/img/icons/home.svg"> {{'LABELS.pump.home' | translate}}
    </div>
    <div (click)="toggleSidebarOpened()" [routerLink]="[routeNavigationConstant.ksmPumpList]"
      class="mt-0 mb-12 py-8 px-20 font-size-16" routerLinkActive="active">
      <img alt="Pumps" class="mr-16 menu-image" src="assets/img/icons/pumps-1.svg">
      {{'LABELS.pump.pumpAndSystem' | translate}}
    </div>
    <div (click)="toggleSidebarOpened()" [routerLink]="[routeNavigationConstant.ksmComplaints]"
      class="mt-0 mb-12 py-8 px-20 font-size-16">
      @if (user?.isComplaintRaised) {
        <span>
          <img alt="" class="position-absolute notification-image" src="assets/img/icons/hamburger-notifications.svg">
        </span>
      }
      @if (!user?.isComplaintRaised) {
        <span>
          <img alt="Complaint" class="mr-12 menu-image" src="assets/img/icons/complaints.svg">
        </span>
      }
      {{'LABELS.pump.complaints' | translate}}
    </div>
    @if (user && user.allRoles && user.allRoles.length) {
      <div (click)="toggleSidebarOpened()" [routerLink]="[routeNavigationConstant.ksmMySites]"
        class="mt-0 mb-12 py-8 px-20 font-size-16">
        <img alt="My Site" class="mr-16 menu-image"
          src="assets/img/icons/my-sites.svg"> {{'LABELS.pump.mySite' | translate}}
        </div>
      }
      @if (isRoleCustomer()) {
        <div (click)="toggleSidebarOpened()" [routerLink]="[routeNavigationConstant.ksmSubscription]"
          class="mt-0 mb-12 py-8 px-20 font-size-16">
          <!--    <span *ngIf="user?.isSubscriptionDue">-->
          <!--      <img alt="" class="subscription-notification-image" src="assets/img/icons/hamburger-notifications.svg">-->
        <!--    </span>-->
        <!--    <span *ngIf="!user?.isSubscriptionDue">-->
        <!--      <img alt="Subscription" class="mr-12 menu-image" src="assets/img/icons/subscriptions.svg">-->
      <!--    </span>-->
      <!--    {{'LABELS.pump.subscription' | translate}}-->
      <!--    <span *ngIf="isSubscription"><img alt="Icon" src="assets/img/icons/red-alert.svg"></span>-->
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          @if (user?.isSubscriptionDue) {
            <span>
              <img alt="" class="subscription-notification-image" src="assets/img/icons/hamburger-notifications.svg">
            </span>
          }
          @if (!user?.isSubscriptionDue) {
            <span>
              <img alt="Subscription" class="mr-12 menu-image" src="assets/img/icons/subscriptions.svg">
            </span>
          }
          {{'LABELS.pump.subscription' | translate}}
        </div>
        @if (user?.isAnyPumpExpired) {
          <div class="lineHeight">
            <img alt="Icon" src="assets/img/icons/hamburger-notifications.svg">
          </div>
        }
      </div>
    </div>
  }
  <div (click)="toggleSidebarOpened()" [routerLink]="[routeNavigationConstant.ksmGeneralHelp]"
    class="mt-0 mb-12 py-8 px-20 font-size-16" routerLinkActive="active">
    <img alt="Help" class="mr-12 menu-image" src="assets/img/icons/help.svg"> {{'LABELS.pump.help' | translate}}
  </div>
  <div class="pl-20 pb-8 mt-40">
    <div class="h3 font-size-16">{{user?.firstName }} {{user?.lastName}}</div>
    @if (roles && roles.trim() !== '') {
      <div fxLayout="row">
        <p #tooltip="matTooltip" class="mt-4 mb-0 role-ellipsis" (click)="tooltip.toggle()"
          [matTooltip]="roles" matTooltipPosition="left">
          {{roles}}
        </p>
      </div>
    }
    <p class="mt-4 mb-0">{{user?.email}}</p>
    <p class="mt-4">{{user?.contact}}</p>
    @if (isCustomer) {
<p [queryParams]="{'email': user?.email,
    'token': token}" [routerLink]="[routeNavigationConstant.ksmChangePassword]" class="mt-16">
        {{'LABELS.auth.changePassword' | translate}}
        <img alt="Arrow Right" class="ml-8 mb-4 menu-image" src="assets/img/icons/arrow-right.svg">
      </p>
    }
    <p [routerLink]="[routeNavigationConstant.ksmLanguage]" class="mt-16" routerLinkActive="mat-accent">
      {{'LABELS.auth.language' | translate}} : <span> {{this.selectedLanguage.name}} </span>
      <img alt="Arrow Right" class="ml-8 mb-4 menu-image" src="assets/img/icons/arrow-right.svg">
    </p>
    <div (click)="logoutUser()" class="pt-16 font-size-16">
      <img alt="Logout" class="mr-12" src="assets/img/icons/Logout.svg"> {{'LABELS.auth.logout' | translate}}
    </div>
  </div>
</div>
}
